import routeNames from "constants/route-names";

// Page name shown in the browser tab after the app name: "<app name> - <page name>".
// Deprecated routes that only redirect are not listed, because no page renders on them.
export const PAGE_TITLE_BY_ROUTE: Record<string, string> = {
	[routeNames.HOME]: "Log In",
	[routeNames.LOGIN]: "Log In",
	[routeNames.SIGNUP]: "Sign Up",
	[routeNames.EMAIL_VERIFICATION_PENDING]: "Email Verification",
	[routeNames.FORGOT_PASSWORD]: "Forgot Password",
	[routeNames.PROOF_CENTER]: "Proof Center",
	[routeNames.PROOF_CENTER_SYSTEM_DETAILS]: "System Details",
	[routeNames.CLAIM_JURISDICTION]: "Your jurisdiction. Your Ollie.",
	[routeNames.CLAIM_JURISDICTION_SETUP]: "A fresh start for your jurisdiction.",
	[routeNames.ADMIN_AUTHORITY_CLAIMS]: "Jurisdiction Claims",
	[routeNames.DASHBOARD]: "Dashboard",
	[routeNames.INSTALLED_DEVICES]: "Devices",
	[routeNames.INSTALLED_DEVICE_DETAILS]: "Device Details",
	[routeNames.INSTALLED_DEVICES_DETAILS]: "Device Details",
	[routeNames.NOTIFICATIONS]: "Notifications",
	[routeNames.ORDER]: "Order",
	[routeNames.SHOP_PRODUCTS_DETAILS]: "Product Details",
	[routeNames.CHECKOUT]: "Checkout",
	[routeNames.REQUEST_SERVICE]: "Request Service",
	[routeNames.AI_CHAT]: "AI Chat",
	[routeNames.GUIDES]: "Guides",
	[routeNames.GUIDE_ADD]: "Add Guide",
	[routeNames.GUIDE_DETAILS]: "Guide Details",
	[routeNames.GUIDE_DETAILS_EDIT]: "Edit Guide",
	[routeNames.EAGLE_EYE]: "Eagle Eye",
	[routeNames.EE_API_TESTER]: "Eagle Eye API Tester",
	[routeNames.HANDOVERS]: "Handovers",
	[routeNames.HANDOVERS_ADD]: "Add Handover",
	[routeNames.HANDOVER_DETAILS]: "Handover Details",
	[routeNames.HANDOVER_DETAILS_EDIT]: "Edit Handover",
	[routeNames.HANDOVER_DEVICE_DETECTION_ADD]: "Device Detection",
	[routeNames.HANDOVER_DEVICE_DETECTION_DETAILS]: "Device Detection",
	[routeNames.OLLIE_CHAT]: "Chat",
	[routeNames.OLLIE_DASHBOARD]: "Dashboard",
	[routeNames.OLLIE_INSPECTION_ADD]: "New Inspection",
	[routeNames.OLLIE_EVIDENCE_COLLECTION]: "Evidence Collection",
	[routeNames.OLLIE_INSPECTION_DETAILS]: "Inspection Details",
	[routeNames.PLAN_REVIEW_ADD]: "New Plan Review",
	[routeNames.PLAN_REVIEW_COLLECTION]: "Select and Upload Your files",
	[routeNames.PLAN_REVIEW_COLLECTION_RESUBMIT]: "Submit Revisions",
	[routeNames.PLAN_REVIEW_SUBMISSIONS]: "Plan Review",
	[routeNames.PLAN_REVIEW_DETAILS]: "Compliance Report",
	[routeNames.PLAN_REVIEW_COMMENTS]: "Comments",
	[routeNames.PLAN_REVIEW_RULES]: "Plan Review Rules",
	[routeNames.PLAN_REVIEW_EXTRACTIONS]: "Rule Extractions",
	[routeNames.PLAN_REVIEW_RULES_EXTRACTION]: "Review Extracted Rules",
	[routeNames.PLAN_REVIEW_RESOURCES]: "Resources",
	[routeNames.PLAN_REVIEW_SUBMISSION_TYPES]: "Submission Types",
	[routeNames.PLAN_REVIEW_FEE_SCHEDULE]: "Fee Schedule",
	[routeNames.PLAN_REVIEW_CATEGORIES]: "Review Categories",
	[routeNames.PLAN_REVIEW_CODES]: "Adopted Codes",
	[routeNames.PLAN_REVIEW_CODE_IMPORTS]: "Code Imports",
	[routeNames.PLAN_REVIEW_CODE_IMPORT]: "Code Import",
	[routeNames.BOUNDARY_AUTHORITY_PROPOSALS]: "Authorities to Confirm",
	[routeNames.BOUNDARY_LAYERS]: "Jurisdiction Maps",
	[routeNames.ADMIN_DASHBOARD]: "Admin",
	[routeNames.ADMIN_DEVICES]: "Devices",
	[routeNames.ADMIN_DEVICES_ADD]: "Add Device",
	[routeNames.ADMIN_DEVICES_DETAILS]: "Device Details",
	[routeNames.ADMIN_DEVICES_EDIT]: "Edit Device",
	[routeNames.ADMIN_USERS]: "Users",
	[routeNames.ADMIN_USER_ADD]: "Add User",
	[routeNames.ADMIN_USER_DETAILS]: "User Details",
	[routeNames.ADMIN_USER_EDIT]: "Edit User",
	[routeNames.ADMIN_ORGANIZATIONS]: "Organizations",
	[routeNames.ADMIN_ORGANIZATION_ADD]: "Add Organization",
	[routeNames.ADMIN_ORGANIZATION_DETAILS]: "Organization Details",
	[routeNames.ADMIN_ORGANIZATION_EDIT]: "Edit Organization",
	[routeNames.ADMIN_PROPERTIES]: "Properties",
	[routeNames.ADMIN_PROPERTY_ADD]: "Add Property",
	[routeNames.ADMIN_PROPERTY_DETAILS]: "Property Details",
	[routeNames.ADMIN_PROPERTY_EDIT]: "Edit Property",
	[routeNames.ADMIN_INSTALLED_DEVICE_ADD]: "Add Installed Device",
	[routeNames.ADMIN_INSTALLED_DEVICE_EDIT]: "Edit Installed Device",
	[routeNames.ADMIN_INSTALLED_DEVICES_DETAILS]: "Installed Device Details",
	[routeNames.ADMIN_TIERS]: "Tiers",
	[routeNames.ADMIN_AI_MODELS]: "AI Models",
	[routeNames.ADMIN_SHOP_PRODUCT_ADD]: "Add Shop Product",
	[routeNames.ADMIN_SHOP_PRODUCTS_DETAILS]: "Shop Product Details",
	[routeNames.ADMIN_INTELLIGENCE]: "Intelligence",
	[routeNames.ADMIN_DEVICE_DETECTIONS]: "Device Detections",
	[routeNames.ADMIN_DEVICE_DETECTION_ADD]: "New Device Detection",
	[routeNames.ADMIN_DEVICE_DETECTION_DETAILS]: "Device Detection",
	[routeNames.NOT_FOUND]: "Page Not Found"
};
